import { useKeyboardHandler } from 'react-native-keyboard-controller';
import { useSharedValue } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

/**
 * Calculates the height required by the keyboard and respects the bottom safe area
 * @returns height + bottom-safe-area of the keyboard, keyboard progress: 0 closed, 1 opened
 */
export const useExtendedKeyboardAnimation = () => {
  const progress = useSharedValue(0);
  const height = useSharedValue(0);

  const { bottom } = useSafeAreaInsets();

  useKeyboardHandler({
    onMove: (e) => {
      'worklet';

      progress.value = e.progress;
      // Add bottom only if keyboard is closed
      height.value = e.height - (e.progress - 1) * bottom;
    },
    onInteractive: (e) => {
      'worklet';

      progress.value = e.progress;
      // Add bottom only if keyboard is closed
      height.value = e.height - (e.progress - 1) * bottom;
    }
  });

  return { height, progress };
};
